"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIG_CONSTANTS = void 0;
exports.CONFIG_CONSTANTS = {
    HUNGER_DECREASE_PER_HOUR: 1,
    HUNGER_MAX: 10,
    SECONDS_PER_HOUR: 6,
};
//# sourceMappingURL=module.js.map